<template>
<v-dialog v-model="dialog" max-width="920" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card color="#f5f5f5">
        <v-card-title class="important primary white--text" height="50">
            User
        </v-card-title>
        <v-avatar v-if="item.avatar" class="elevation-4" style="position: absolute; right: 50px; top: 25px;cursor: pointer;" @click="onFilePick()">
            <img :src="item.avatar">
        </v-avatar>
        <v-btn v-else fab class="mx-3 elevation-4 secondary" style="position: absolute; right: 50px; top: 15px;" @click="onFilePick()">
            <v-icon color="primary">photo_camera</v-icon>
        </v-btn>
        <v-card-text class="pt-4">
            <v-form ref="form_user" v-model="valid" autocomplete="off">
                <im-details class="my-2" :item="item" />
                <im-email-pass class="my-2" :item="item" />
                <im-edit-roles class="my-2" v-if="item_id" :item_id="item_id" />
                <im-create-roles class="my-2" v-else :item_id="item_id" @roles="updateRoles($event)" :dialog="dialog" />
                <im-address class="my-2" :item="item" />
                <im-social class="my-2" :item="item" />
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="emitExit()">Cancel</v-btn>
            <v-btn color="primary" @click="save()" :loading="loading_save">Save</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import IMDetails from "./Details.vue";
import IMEmailPass from "./EmailPass.vue";
import IMCreateRoles from "./CreateRoles.vue";
import IMEditRoles from "./EditRoles.vue";
import IMAddress from "./Address.vue";
import IMSocial from "./Social.vue";

export default {
    components: {
        'im-details': IMDetails,
        'im-email-pass': IMEmailPass,
        'im-create-roles': IMCreateRoles,
        'im-edit-roles': IMEditRoles,
        'im-address': IMAddress,
        'im-social': IMSocial,
    },

    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        item_id: [Number, String],

    },
    data() {
        return {
            // service
            loading_save: false,
            valid: null,
            roles: [],
            original_email: null,
            item: this.$clone(defaults.user_item)
        }
    },
    watch: {
        dialog: {
            handler() {
                this.valid = null;
                this.original_email = null;
                this.roles = [];
                if(this.dialog && this.item_id) {
                    this.getItem();
                } else {
                    this.birthdate = null;
                    this.item = this.$clone(defaults.user_item);
                }
            }
        }

    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        emitExit() {
            this.$emit('exit')
        },

        getItem() {

            if(!this.item_id) {
                return
            }
            this.data_loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/users/";

            this.$axios.get(endpoint + this.item_id)
                .then(response => {
                    this.item = response.data;
                    this.original_email = this.$clone(response.data.email);
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.data_loading = false;
                });

        },

        save() {
            // validate
            if(!this.$refs.form_user.validate()) {
                return;
            }
            // we are loading
            this.loading_save = true;

            // call update or save endpoints
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint_profiles = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/users";
            let endpoint_auth = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/auth/v1/users";

            if(this.item_id) {
                if(this.original_email !== this.item.email || this.item.password) {
                    let user_model = {
                        email: this.item.email,
                        first_name: this.item.first_name,
                        password: this.item.password,
                        password_confirmation: this.item.password_confirmation,
                    };
                    this.$axios.put(endpoint_auth + "/" + this.item.id, user_model)
                        .then(response => {
                            this.success('User email updated!');
                        })
                        .catch(error => {
                            if(error.response && error.response.status === 422) {
                                this.error(`${this.user.email} is already taken.`);
                            } else {
                                this.error("Oops, something went wrong!");
                            }
                        })
                        .finally(() => {});
                }

                this.$axios.put(endpoint_profiles + "/" + this.item.user_id, this.item) // eslint-disable-next-line
                    .then(response => {
                        this.success('User updated!');
                        this.emitExit();
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.error(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                // return
                this.$axios.post(endpoint_auth, this.item) // eslint-disable-next-line
                    .then(async response => {
                        let user_id = response.data.id;

                        let promises = []
                        if(this.roles.length) {
                            promises = await this.roles.map(function (service) {
                                let role_id = service.roles.map(async function (role) {
                                    await this.saveRoles(user_id, role.role_id)
                                }.bind(this))
                            }.bind(this))

                        }
                        Promise.all(promises)
                            .then(() => {
                                this.roles = [];
                                this.loading_save = false;
                                this.emitExit();
                            })
                            .catch(error => {
                                this.getItem();
                                console.log(error);
                                this.loading_save = false;
                                this.error('Oops, something went wrong!');
                            })
                        this.success('User created!');
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.error(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        saveRoles(user_id, role_id) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles";

            return this.$axios.post(endpoint + "/users/" + user_id + "/roles/" + role_id) // eslint-disable-next-line
                .then(response => {
                    this.success('Role created');
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.role_dialog = false;
                });
        },

        updateRoles(value) {
            this.roles = value;
        }

    }
}
</script>
